import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=eb58dfe2&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=eb58dfe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb58dfe2",
  null
  
)

export default component.exports